var _ImageComponent_ps, _ImageComponent_state;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { BaseComponent } from './BaseComponent';
export class ImageComponent extends BaseComponent {
    constructor(compRef, ps) {
        super(compRef);
        this.type = 'image';
        _ImageComponent_ps.set(this, void 0);
        _ImageComponent_state.set(this, {});
        __classPrivateFieldSet(this, _ImageComponent_ps, ps, "f");
    }
    async init() {
        const data = __classPrivateFieldGet(this, _ImageComponent_ps, "f").ds.components.data.get(this.compRef);
        __classPrivateFieldGet(this, _ImageComponent_state, "f").src = data?.image?.uri;
    }
    src(src) {
        if (typeof src === 'undefined') {
            return __classPrivateFieldGet(this, _ImageComponent_state, "f").src;
        }
        else {
            __classPrivateFieldGet(this, _ImageComponent_state, "f").src = src;
            const data = __classPrivateFieldGet(this, _ImageComponent_ps, "f").ds.components.data.get(this.compRef);
            __classPrivateFieldGet(this, _ImageComponent_ps, "f").ds.components.data.update(this.compRef, {
                ...data,
                image: {
                    ...data.image,
                    uri: src,
                },
            });
            return void 0;
        }
    }
}
_ImageComponent_ps = new WeakMap(), _ImageComponent_state = new WeakMap();
//# sourceMappingURL=ImageComponent.js.map